import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';

import { Theme } from 'styles/ThemeTyping';

interface Props {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  caption: string;
  header: string;
  status: 'success' | 'error';
}

function SyncDetailsModal({ children, open, onClose, title, caption, header, status }: Props) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.modal}>
        <div className={classNames(classes.strip, classes[status])} />
        <div className={classes.summary}>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.caption}>{caption}</Typography>
          <Typography className={classes.header}>{header}</Typography>
          {children}
        </div>
      </div>
    </Modal>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  modal: {
    width: 360,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(0.5),
  },
  strip: {
    width: '100%',
    minHeight: 10,
    borderRadius: `${theme.spacing(0.5)}px ${theme.spacing(0.5)}px 0px 0px`,
  },
  caption: {
    ...theme.typography.caption,
    marginBottom: theme.spacing(3.375),
  },
  error: {
    backgroundColor: theme.palette.error.main,
  },
  success: {
    backgroundColor: theme.palette.secondary.light,
  },
  title: {
    ...theme.typography.h5Semibold,
    marginBottom: theme.spacing(),
    display: 'flex',
    alignItems: 'center',
  },
  summary: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(),
  },
  header: {
    fontWeight: theme.typography.h5Semibold.fontWeight,
  },
}));

export default SyncDetailsModal;
